import { defineMessages } from 'react-intl'

export const PROFILE_GOAL_OBSTACLE = {
  LACK_OF_CONSISTENCY: 'LACK_OF_CONSISTENCY',
  POOR_EATING_HABITS: 'POOR_EATING_HABITS',
  BUSY_SCHEDULE: 'BUSY_SCHEDULE',
  DONT_KNOW_WHAT_WORKOUTS_TO_DO: 'DONT_KNOW_WHAT_WORKOUTS_TO_DO',
  LACK_OF_SUPPORT: 'LACK_OF_SUPPORT'
}

export const PROFILE_GOAL_OBSTACLES = Object.values(PROFILE_GOAL_OBSTACLE)

const labels = defineMessages({
  lackOfConsistency: {
    id: 'ProfileGoalObstacle.lackOfConsistency',
    defaultMessage: 'Lack of consistency',
    description: 'Obstacle where the user struggles with staying consistent.'
  },
  poorEatingHabits: {
    id: 'ProfileGoalObstacle.poorEatingHabits',
    defaultMessage: 'Poor eating habits',
    description: 'Obstacle where the user has unhealthy eating patterns.'
  },
  busySchedule: {
    id: 'ProfileGoalObstacle.busySchedule',
    defaultMessage: 'Busy schedule',
    description: 'Obstacle where the user has a very busy schedule.'
  },
  dontKnowWhatWorkoutsToDo: {
    id: 'ProfileGoalObstacle.dontKnowWhatWorkoutsToDo',
    defaultMessage: 'Don\'t know what workouts to do',
    description: 'Obstacle where the user is unsure what workouts to perform.'
  },
  lackOfSupport: {
    id: 'ProfileGoalObstacle.lackOfSupport',
    defaultMessage: 'Lack of support or accountability',
    description: 'Obstacle where the user lacks encouragement or guidance.'
  }
})

export const PROFILE_GOAL_OBSTACLE_MESSAGE = {
  [PROFILE_GOAL_OBSTACLE.LACK_OF_CONSISTENCY]: labels.lackOfConsistency,
  [PROFILE_GOAL_OBSTACLE.POOR_EATING_HABITS]: labels.poorEatingHabits,
  [PROFILE_GOAL_OBSTACLE.BUSY_SCHEDULE]: labels.busySchedule,
  [PROFILE_GOAL_OBSTACLE.DONT_KNOW_WHAT_WORKOUTS_TO_DO]: labels.dontKnowWhatWorkoutsToDo,
  [PROFILE_GOAL_OBSTACLE.LACK_OF_SUPPORT]: labels.lackOfSupport
}

export const PROFILE_GOAL_OBSTACLE_EMOJI = {
  [PROFILE_GOAL_OBSTACLE.LACK_OF_CONSISTENCY]: '🔁',
  [PROFILE_GOAL_OBSTACLE.POOR_EATING_HABITS]: '🍔',
  [PROFILE_GOAL_OBSTACLE.BUSY_SCHEDULE]: '⏰',
  [PROFILE_GOAL_OBSTACLE.DONT_KNOW_WHAT_WORKOUTS_TO_DO]: '🤔',
  [PROFILE_GOAL_OBSTACLE.LACK_OF_SUPPORT]: '🙋'
}
